import React, { Component } from 'react'
import { Tab } from 'semantic-ui-react'

import CartBasedPromotion from '../../components/cartBased'
import PromotionsList from '../../components/promotions/views/PromotionsList'
import PickUpPromotionsList from '../../components/pickUpPromotions/views/PromotionsList'
import SpecialDeal from '../../components/specialDeal'
import DeliveryFeeOffer from '../../components/deliveryFeeOffer'

import FreeCheckouts from './components/FreeCheckouts'
import QuantityPromotions from './components/QuantityPromotions'

import utils from '../../utils'

class PromotionContainer extends Component {
  tabPanes = () => ({
    discount: {
      menuItem: 'Discount',
      render: this.renderDiscount,
    },
    'pick-up-discount': {
      menuItem: 'Pick Up Discount',
      render: this.renderPickUpPromotions
    },
    'cart-based': {
      menuItem: 'Cart Based',
      render: this.renderCartBased,
    },
    'special-deals': {
      menuItem: 'Special Deals',
      render: this.renderSpecialDeal,
    },
    'delivery-fee-offer': {
      menuItem: 'Delivery Fee Offers',
      render: this.renderDeliveryFeeOffer,
    },
    'free-checkouts': {
      menuItem: 'Free Checkouts',
      render: this.renderFreeCheckout,
    },
    'quantity-promotions': {
      menuItem: 'Quantity',
      render: this.renderQuantityPromotions,
    },
  })

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/promotions${queryString}`)
  }

  renderPickUpPromotions = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <PickUpPromotionsList />
      </Tab.Pane>
    )
  }

  renderDiscount = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <PromotionsList />
      </Tab.Pane>
    )
  }

  renderCartBased = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <CartBasedPromotion />
      </Tab.Pane>
    )
  }

  renderSpecialDeal = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <SpecialDeal />
      </Tab.Pane>
    )
  }

  renderDeliveryFeeOffer = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <DeliveryFeeOffer />
      </Tab.Pane>
    )
  }

  renderFreeCheckout = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <FreeCheckouts />
      </Tab.Pane>
    )
  }

  renderQuantityPromotions = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <QuantityPromotions />
      </Tab.Pane>
    )
  }

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'discount'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <Tab
        activeIndex={tabIndex}
        menu={{ pointing: true }}
        panes={Object.values(this.tabPanes())}
        onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
      />
    )
  }
}

export default PromotionContainer



// WEBPACK FOOTER //
// ./src/containers/promotions/index.js